"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentPdfPrintImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentPdfPrint operations. */
var DocumentPdfPrintImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentPdfPrint class.
   * @param client Reference to the service client
   */
  function DocumentPdfPrintImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentPdfPrintImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentPdfPrintImpl, [{
    key: "printToPdf",
    value: function printToPdf(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, printToPdfOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "printToPdfBase",
    value: function printToPdfBase(portalId, hiveId, fullName, body, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, printToPdfBaseOperationSpec);
    }
  }]);
  return DocumentPdfPrintImpl;
}(); // Operation Specifications


exports.DocumentPdfPrintImpl = DocumentPdfPrintImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var printToPdfOperationSpec = {
  path: "/api/Portals({portalId})/Print/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept1],
  serializer: serializer
};
var printToPdfBaseOperationSpec = {
  path: "/api/Portals({portalId})/Print/h/{hiveId}/{fullName}",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  requestBody: Parameters.body16,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.contentType, Parameters.accept3],
  mediaType: "json",
  serializer: serializer
};